import { getCategoryAncestors } from '~/lib/category/ancestors';

export const useCategoryAncestors = async (
  pCategory: CategorySchema | Ref<CategorySchema>,
  libraryBookId: string
): Promise<Ref<CategorySchema[]>> => {
  const { $db } = useNuxtApp();

  const category = toValue(pCategory);

  const ancestors = ref<CategorySchema[]>([]);

  const allAncestors = await getCategoryAncestors($db, category, libraryBookId);

  ancestors.value = allAncestors;

  return ancestors;
};
